import { resolveCrmxV2KitEnabled, resolveCrmxSettingsEnabled } from "./feature-flag-runtime";

export const crmxV2KitEnabled = resolveCrmxV2KitEnabled(
  import.meta.env.VITE_CRMX_V2_KIT_ENABLED === "true",
  import.meta.env.VITE_CRMX_V2_KIT_RUNTIME_OVERRIDE_ENABLED,
  window.location.search,
);

export const crmxSettingsEnabled = resolveCrmxSettingsEnabled(
  import.meta.env.VITE_CRMX_SETTINGS_ENABLED === "true",
  import.meta.env.VITE_CRMX_V2_KIT_RUNTIME_OVERRIDE_ENABLED,
  window.location.search,
);
